import { useContext } from "react";
import { AppDependenciesContext } from "./AppDependenciesContext";

/**
 * Returns the application's underlying, stateful dependencies.
 *
 * Use this instead of importing and relying on stateful dependencies directly
 * to enable easier React testing via the {@link AppDependenciesContext} (without
 * mocks).
 */
export function useAppDependenciesContext() {
  return useContext(AppDependenciesContext);
}
